import type { ValidItem } from 'src/types/api';
import type { Item as TransactionItem } from 'src/types/proto/transactions';
import Avid from './avid';
import Chore from './chore';
import CoverPhoto from './cover-photo';
import CoverSheet from './cover-sheet';
import Dpp from './dpp';
import Folder from './folder';
import GuidedFormPacket from './guided-form-packet';
import GuidedFormPacketFlow from './guided-form-packet-flow';
import Invoice from './invoice';
import Item, { ItemStore } from './item';
import ItemLabel from './item-label';
import ListingInfo from './listing-info';
import LoadSummary from './load-summary';
import Nhd from './nhd';
import Offer from './offer';
import Packet from './packet';
import Party from './party';
import PropertyInfo from './property-info';
import PurchaseInfo from './purchase-info';
import SharePacket from './share-packet';
import SharePacketPublication from './share-packet-publication';
import SignatureRequest from './signature-request';
import SyncRecord from './sync-record';
import Task from './task';
import TaskReminder from './task-reminder';
import TemplateSetting from './template-setting';
import TransactionApp from './transaction-app';
import TransactionDocument from './transaction-document';
import TransactionDocumentVersion from './transaction-document-version';
import TransactionFields from './transaction-fields';
import TransactionPackage from './transaction-package';

const ITEM_MODEL_BY_KIND = {
  CHORE: Chore,
  COVER_PHOTO: CoverPhoto,
  FOLDER: Folder,
  GUIDED_FORM_PACKET: GuidedFormPacket,
  GUIDED_FORM_PACKET_FLOW: GuidedFormPacketFlow,
  INVOICE: Invoice,
  ITEM_LABEL: ItemLabel,
  LISTING_INFO: ListingInfo,
  LOAD_SUMMARY: LoadSummary,
  PACKET: Packet,
  PARTY: Party,
  PROPERTY_INFO: PropertyInfo,
  PURCHASE_INFO: PurchaseInfo,
  SIGNATURE_REQUEST: SignatureRequest,
  SHARE_PACKET: SharePacket,
  SHARE_PACKET_PUBLICATION: SharePacketPublication,
  TASK: Task,
  TEMPLATE_SETTING: TemplateSetting,
  TRANSACTION_APP: TransactionApp,
  TRANSACTION_DOCUMENT: TransactionDocument,
  TRANSACTION_DOCUMENT_VERSION: TransactionDocumentVersion,
  TRANSACTION_FIELDS: TransactionFields,
  SYNC_RECORD: SyncRecord,
  TASK_REMINDER: TaskReminder,
  COVER_SHEET: CoverSheet,
  NHD: Nhd,
  DPP: Dpp,
  AVID: Avid,
  OFFER: Offer,
  TRANSACTION_PACKAGE: TransactionPackage,
};

export type ItemModelMap = typeof ITEM_MODEL_BY_KIND;
export type ItemModelMapKey = keyof ItemModelMap;
export type ItemModels = InstanceType<
  typeof ITEM_MODEL_BY_KIND[ItemModelMapKey]
>;

export function makeItem<T extends ValidItem<TransactionItem>>(
  store: ItemStore,
  json: T
): T['kind'] extends ItemModelMapKey
  ? ItemModelMap[T['kind']]
  : Item<T['kind']> {
  // @ts-expect-error Other kind is handled by base class
  const ItemModel = ITEM_MODEL_BY_KIND[json.kind] || Item;
  return new ItemModel(store, json);
}
